// extracted by mini-css-extract-plugin
module.exports = {"root":"IconMessage_root__2oYGU"};